import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const LabelPrinter: FC<SvgIconProps> = ({ viewBox = '0 0 255 169', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props}>
    <path
      opacity=".5"
      d="M79.545 146.776l35.95-7.02-61.201-30.42-36.164 7.02 61.415 30.42z"
      fill="url(#labelPrinter_paint0_linear)"
    />
    <path d="M115.495 74.448l86.88-15.317-61.415-30.42L54.294 44.24l61.201 30.208z" fill="#FDDE84" />
    <path d="M115.495 74.448v65.308l-61.201-30.42V44.24l61.201 30.208z" fill="#C39000" />
    <path d="M118.063 64.662l52.641-9.36-42.37-22.55-55.423 9.573 45.152 22.337z" fill="#000" />
    <path d="M115.495 74.448v65.308l86.88-15.529V59.131l-86.88 15.317z" fill="#FCCE09" />
    <path d="M132.614 94.87l52.642-8.935v-2.553l-52.642 8.935v2.553z" fill="#000" />
    <path
      d="M114.853 68.279c2.14-.851 4.28-.851 6.42 0 1.711.638 1.925 1.914.214 2.552-2.14.851-4.28.851-6.42 0-1.926-.85-1.926-1.914-.214-2.552z"
      fill="#870310"
    />
    <path d="M113.355 67.64v1.915h8.988V67.64" fill="#870310" />
    <path
      d="M158.721 57.43l2.354-.426c1.284-5.531.642-11.275-2.14-16.168-5.35-10.849-17.119-15.955-26.321-11.487-4.494 2.127-7.703 6.169-8.773 11.062"
      fill="#fff"
    />
    <path
      d="M114.853 66.364c2.14-.85 4.28-.85 6.42 0 1.711.638 1.925 1.915.214 2.553-2.14.85-4.28.85-6.42 0-1.926-.638-1.926-1.915-.214-2.553z"
      fill="#D40511"
    />
    <path d="M181.404 115.93l46.65-8.296-46.436-22.762-46.864 8.296 46.65 22.762z" fill="#EFEFEF" />
    <path
      d="M170.704 104.868c2.568 1.277 4.922 2.34 7.49 3.617l24.181-3.829c-2.568-1.277-4.922-2.34-7.49-3.617a5771.913 5771.913 0 01-24.181 3.829zM150.161 95.083c2.14 1.063 4.28 2.127 6.206 2.978a5951.51 5951.51 0 0024.181-3.83c-2.14-1.063-4.066-1.914-6.206-2.977l-24.181 3.829zM163.429 101.465c1.07.425 1.926 1.063 2.995 1.489 8.132-1.277 16.264-2.553 24.181-3.83-1.07-.425-2.14-1.063-2.996-1.489-8.131 1.277-16.263 2.553-24.18 3.83zM208.795 107.847c-1.07-.426-2.14-1.064-3.21-1.49-8.132 1.277-16.264 2.553-24.181 3.83 1.07.425 2.14 1.063 3.21 1.489 8.131-1.277 16.263-2.553 24.181-3.829zM160.005 99.763l1.284.638c8.131-1.276 16.263-2.553 24.181-3.83l-1.284-.637-24.181 3.829z"
      fill="#000"
    />
    <path
      d="M120.845 59.344c0-3.83-.856-7.658-2.568-11.275-5.35-10.85-17.119-15.955-26.107-11.487-2.354 1.276-4.494 3.19-6.206 5.318l34.881 17.444z"
      fill="#CCC"
    />
    <path d="M161.289 57.004l-41.086 7.233-.642-6.808 42.156-6.807-.428 6.382z" fill="#fff" />
    <path
      d="M118.063 64.662l2.354-.425c1.284-5.531.642-11.275-2.14-16.168-5.35-10.85-17.119-15.955-26.321-11.487-4.494 2.127-7.704 6.169-8.774 11.062"
      fill="#CCC"
    />
    <path
      d="M118.491 48.07c1.712 3.403 2.568 7.445 2.568 11.274l40.872-7.233c0-3.83-.856-7.658-2.568-11.275-4.494-9.147-13.695-14.253-21.827-12.764L97.734 34.88c7.917-.426 16.049 4.467 20.757 13.19z"
      fill="#fff"
    />
    <g opacity=".4">
      <path
        opacity=".6"
        d="M114.425 50.197c2.14 4.467 3.424 9.36 3.424 14.465l52.641-9.36c0-5.105-1.284-9.998-3.424-14.466-5.777-11.7-17.547-18.295-28.032-16.593L87.89 33.391c10.486-.851 21.185 5.743 26.535 16.806z"
        fill="#4C4C4C"
      />
    </g>
    <path
      opacity=".8"
      d="M118.063 64.662c0-5.105-1.284-9.998-3.424-14.466-6.848-14.04-22.041-20.634-33.81-14.89-3.21 1.701-5.992 4.041-7.918 7.02l45.152 22.336z"
      fill="#4C4C4C"
    />
    <path
      opacity=".5"
      d="M161.717 50.835V49.77c0-.425 0-.85-.214-1.276 0-.639-.214-1.064-.214-1.702 0-.638-.214-1.064-.428-1.702 0-.213-.214-.425-.214-.638-.428-1.277-.856-2.553-1.498-3.83-.214-.425-.428-.638-.642-1.063l-.642-1.277c-.428-.425-.642-1.063-.856-1.489-.428-.638-.856-1.276-1.498-1.701-.428-.213-.856-.426-1.07-.851l-1.284-1.277c-.428-.425-.856-.638-1.284-1.063-.428-.426-1.07-.851-1.712-1.277-.214 0-.428-.212-.856-.212l-2.568-1.277c-.214 0-.214-.213-.428-.213-3.209-1.276-6.847-1.701-10.271-.85l-37.662 7.02c1.712 0 3.638.212 5.349.638.214 0 .428 0 .642.212.856.213 1.712.426 2.354.851.214.213.642.213.856.426.642.213 1.07.425 1.498.85.428.213.642.426 1.07.639.642.425 1.284.85 1.712 1.276.428.213.642.639 1.07 1.064l.856.851c.642.638 1.07 1.276 1.712 1.915.214.425.428.638.642 1.063.214.426.642.851.856 1.277.214.425.428.638.642 1.063.214.426.428.638.642 1.064.642 1.064 1.07 2.34 1.498 3.616 0 .213.214.638.214.851 0 .213.214.426.214.638 1.07 3.617 1.07 7.659.214 11.275l40.872-7.233c.428-1.702.642-3.403.642-5.105v-.426c-.214-.212-.428-.638-.214-1.063z"
      fill="#fff"
    />
    <path
      opacity=".5"
      d="M161.717 50.835V49.77c0-.425 0-.85-.214-1.276 0-.639-.214-1.064-.214-1.702 0-.638-.214-1.064-.428-1.702 0-.213-.214-.425-.214-.638-.428-1.277-.856-2.553-1.498-3.83-.214-.425-.428-.638-.642-1.063l-.642-1.277c-.428-.425-.642-1.063-.856-1.489-.428-.638-.856-1.276-1.498-1.701-.428-.213-.856-.426-1.07-.851l-1.284-1.277c-.428-.425-.856-.638-1.284-1.063-.428-.426-1.07-.851-1.712-1.277-.214 0-.428-.212-.856-.212l-2.568-1.277c-.214 0-.214-.213-.428-.213-3.209-1.276-6.847-1.701-10.271-.85l-37.662 7.02c1.712 0 3.638.212 5.349.638.214 0 .428 0 .642.212.856.213 1.712.426 2.354.851.214.213.642.213.856.426.642.213 1.07.425 1.498.85.428.213.642.426 1.07.639.642.425 1.284.85 1.712 1.276.428.213.642.639 1.07 1.064l.856.851c.642.638 1.07 1.276 1.712 1.915.214.425.428.638.642 1.063.214.426.642.851.856 1.277.214.425.428.638.642 1.063.214.426.428.638.642 1.064.642 1.064 1.07 2.34 1.498 3.616 0 .213.214.638.214.851 0 .213.214.426.214.638 1.07 3.617 1.07 7.659.214 11.275l40.872-7.233c.428-1.702.642-3.403.642-5.105v-.426c-.214-.212-.428-.638-.214-1.063z"
      fill="#fff"
    />
    <path
      opacity=".5"
      d="M161.717 50.622v-1.49l-40.872 7.234c.428 2.552.214 5.318-.428 7.87l40.872-7.232c.428-1.702.642-3.404.642-5.106v-1.276h-.214z"
      fill="#C9C9C9"
    />
    <defs>
      <linearGradient
        id="labelPrinter_paint0_linear"
        x1="56.842"
        y1="133.948"
        x2="66.518"
        y2="113.212"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
